<script>
export default {
    name: 'IconTrash'
}
</script>
<template>
    <svg
        class="base-icon icon-trash"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M44 8v6h12v6h-6v36H14V20H8v-6h12V8h24zM29 24v24h-4V24h4zm10 0v24h-4V24h4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
